import { Profile } from "../../../../services/profileService/model/profile/Profile";

export interface ConflictingAssignment {
    userName: string;
    upn: string;
    value: string;
}

export function findConflictingAssignments(
    allProfiles: Profile[] | undefined,
    assignmentType: string,
    processType: string,
    values: string[],
    excludeUpn?: string
): ConflictingAssignment[] {
    if (!allProfiles) return [];

    const conflicts: ConflictingAssignment[] = [];

    for (const profile of allProfiles) {
        if (excludeUpn && profile.upn === excludeUpn) continue;

        const matchingAssignment = profile.vobAssignments?.find(a =>
            a.assignmentTypeCode === assignmentType &&
            a.processTypeCode === processType
        );

        if (matchingAssignment) {
            for (const value of values) {
                if (matchingAssignment.assignmentValues?.includes(value)) {
                    conflicts.push({
                        userName: profile.identity || profile.fullName || profile.email || profile.upn,
                        upn: profile.upn,
                        value
                    });
                }
            }
        }
    }

    return conflicts;
}
